import React, { useEffect, useState } from "react";
import { Button } from "./Button";
import { api, PLATFORM_ROUTE, _loginFormNotOk } from "./helpers";
import { Input } from "./Input";
import Link from "next/link";
import router from "next/router";
import { Some } from "./helpers/option";
import { cookie_write } from "./helpers/cookies";
import { Callout } from "./Callout";

declare global {
    // eslint-disable-next-line no-unused-vars
    interface Window {
        dataLayer: any;
    }
}
export function APILogin({ setUser, setToken, visitor, handleToast, adBlock }) {
    const [user, setUserForm] = useState({
        name: "",
        email: "",
        password: ""
    });
    const [load, setLoad] = useState<boolean>(false);
    const [busy, setBusy] = useState(false);
    const [verifyEmail, setVerify] = useState<boolean>(false);

    useEffect(() => {
        const keyDownHandler = event => {

            if (event.key === 'Enter') {
                event.preventDefault();
                handleLogin();
            }
        };

        document.addEventListener('keydown', keyDownHandler);

        return () => {
            document.removeEventListener('keydown', keyDownHandler);
        };
    }, [user]);

    useEffect(() => {
        setBusy(_loginFormNotOk(user.email, user.password));
    }, [user]);

    const handleLogin = async () => {
        setLoad(true);
        const resp = await api.login_covalent(user.email, user.password, visitor.id, visitor.visitor_locale, visitor.visitor_timezone);
        if (!resp || resp.error) {
            if (resp) {
                if (resp?.error_code === 1003) {
                    setUser(new Some(resp.data.user));
                    setToken(resp.data.token);
                    cookie_write("cov_token", resp.data.token);
                    return router.push(`/${PLATFORM_ROUTE}/auth/create_group`);
                }
                if (resp?.error_code === 1004) {
                    handleToast({
                        error: true,
                        error_message: "No password set. Try resetting your password."
                    });
                    return;
                }
                if (resp.error_code === 1002) {
                    setVerify(true);
                }
                handleToast({
                    error: true,
                    error_message: resp.error_message
                });
            }
        } else {
            setUser(new Some(resp.data.user));
            setToken(resp.data.token);
            cookie_write("cov_token", resp.data.token);
            // handleToast({
            //     title: "Successfully logged in."
            // });
            router.push(`/${PLATFORM_ROUTE}`);
        }
        setLoad(false);
    };

    const handleResend = async () => {
        const resp = await api.resend_email_covalent(user.email);
        if (!resp || resp.error) {
            handleToast({
                error: true,
                error_message: resp?.error_message
            });
        } else {
            handleToast({
                title: "Successfully resent verification email.",
                description: "Please check your email."
            });
        }
    };

    return <>
        <div className="login-container">
            <h2>{verifyEmail ? "Verify your email" : "Login to Covalent"
            }</h2>
            {verifyEmail ?
                <>
                    <p>Email verification required. Please check your email for a verification link.</p>
                    <div onClick={handleResend} className="re-send">Resend verification email</div>
                </>
                :
                <>
                    {adBlock &&
                        <Callout title={undefined} type={"warning"}>
                            Please disable adblockers and VPNs. Some browsers like Brave are currently not supported.
                        </Callout>
                    }
                    <Input type="email" label="Email" autofill="email" placeholder="Enter your email" onChange={(e) => {
                        setUserForm({ ...user, ...{ email: e.target.value } });
                    }} />
                    <Input type="password" label="Password" autofill="current-password" placeholder="Enter your password" onChange={(e) => {
                        setUserForm({ ...user, ...{ password: e.target.value } });
                    }} />
                    <div className="login-button">
                        <Button fill load={load ? true : undefined} disabled={busy || load} onClick={handleLogin}>Login</Button>
                    </div>
                    <Link href={`/${PLATFORM_ROUTE}/auth/register/`}>Don't have an account? Register here</Link>
                    <Link href={`/${PLATFORM_ROUTE}/auth/forgot_password/`}>Forgot Password?</Link>
                </>
            }

        </div>
        <style jsx>
            {`
            h2{
                font-size: var(--font-size-6);
                line-height: var(--line-height-6);
            }
            .re-send{
                color:var(--pink);
            }
            .re-send:hover{
                cursor: pointer;
            }
            .login-container{
                display:flex;
                flex-direction: column;
                gap:2rem;
                width:100%;
            }
            .login-button {
                display: block;
                margin-top: 0.25rem;
            }
            .forgot-link {
                display: block;
                margin-top: 0.5rem;
            }
            `}
        </style>
    </>;
}
